module.exports = "../../app/cells/pages/landing_xray/index/related_cell.rb";